import { useTranslation } from "react-i18next";
import SectionCard from "../../components/SectionCard";
import SectionRow from "../../components/SectionRow";

function Address({ user }: any) {
    const { t } = useTranslation();
    const address = user?.address;

    return (
        <SectionCard title={t("address")}>
            <SectionRow label={t("country")} value={address?.country?.name} />
            <SectionRow label={t("address1")} value={address?.address} />
            <SectionRow label={t("address2")} value={address?.address2} />
            <SectionRow label={t("city")} value={address?.city} />
            <SectionRow label={t("state-or-province")} value={address?.stateOrProvince} />
            <SectionRow label={t("postal-code")} value={address?.zip} />
        </SectionCard>
    );
}

export default Address;
